import Splide from '@splidejs/splide';

let testimonialSlides = document.getElementsByClassName('testimonial-slider');
let testimonialNav = document.getElementsByClassName('application-slider-nav');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < testimonialSlides.length; i++) {
        let content = new Splide(testimonialSlides[i], {
            type: 'fade',
            pagination: false,
            arrows: false,
            rewind: true,
            perPage: 1,
            width: '100%',
        });

        let nav = new Splide(testimonialNav[i], {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            rewind: true,
            pagination: false,
            isNavigation: true,
            arrows: false
        });

        content.on('move', (newIndex) => {
            const upcomingSlide = content.Components.Elements.slides[newIndex];
            const upcomingText = upcomingSlide.querySelector('.animate-text p');
            const upcomingTitle = upcomingSlide.querySelectorAll('.animate-title');

            upcomingTitle.forEach(function (self) {
                gsap.to(
                    self,
                    {autoAlpha: 1}
                );

                let split = new SplitText(self.querySelector('.title'), {charsClass: 'chars', linesClass: 'lines'})

                gsap.from(split.chars, 1, {
                    duration: 0.2,
                    y: 20,
                    autoAlpha: 0,
                    ease: 'power3.out',
                    stagger: 0.03,
                    delay: '>-75%'
                });
            });

            gsap.fromTo(
                upcomingText,
                {opacity: 0, y: 20},
                {opacity: 1, y: 0, duration: 1, delay: 0.2}
            );
        });

        //sync the content with the navigation
        content.sync(nav);
        content.mount();
        nav.mount();
    }
});



